import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Box, Button } from '@doda/io-react/common';
import styles from './index.module.scss';
import { useBannerVisible } from '../BannerVisibilityContext';

/**
 * BottomBannerProps
 */
interface BottomBannerProps {
  buttonHref: string;
  onDisplay?: () => void;
  onClick?: () => void;
}

/**
 * RegistSuggestionBanner Component
 * @param {string} buttonHref href for button onClick event
 * @param {void} onDisplay Optional callback triggered the first time the banner becomes visible.
 * @param {void} onClick Optional callback triggered when the button is clicked.
 */
export const RegistSuggestionBanner: React.FC<BottomBannerProps> = ({
  buttonHref,
  onDisplay,
  onClick,
}) => {
  const isVisible = useBannerVisible();
  const hasDisplayed = useRef(false);
  useEffect(() => {
    if (isVisible && !hasDisplayed.current) {
      onDisplay?.();
      hasDisplayed.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <Box
      color="black"
      boxShadow="black"
      className={classNames(styles['regist-banner'], {
        [styles['regist-banner--visible']]: isVisible,
      })}
    >
      <div className={styles['regist-banner__text']}>
        <p className={styles['regist-banner__headline']}>
          気になる求人はありましたか？
        </p>
        <p className={styles['regist-banner__subtext']}>
          会員登録でより志向に合う情報をお届け！
        </p>
      </div>
      <Button
        size="M"
        as="a"
        variant="orange"
        href={buttonHref}
        onClick={onClick}
        className={styles['regist-banner__cta']}
      >
        <span className={styles['regist-banner__icon']} />
        <div className={styles['regist-banner__cta-text']}>
          <p>会員登録する</p>
          <p className={styles['regist-banner__cta-subtext']}>（無料）</p>
        </div>
      </Button>
    </Box>
  );
};
